// extracted by mini-css-extract-plugin
export var cartouche = "cartouche-module--cartouche--2uOKa";
export var noPadding = "cartouche-module--noPadding--16LbM";